import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from '@/AxiosRequests';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages:{},
});

// запрашивает и устанавивает все переводы для языка
export function setTranslations(lang) {
  axios.langs.getLang({ lang }).then((response) => {
    const res = response.data;
    i18n.setLocaleMessage(lang, res);
    i18n.locale = lang;
  });
}